export default "__VITE_ASSET__BsqqHVgP__"